module.exports = __webpack_public_path__ + "media/logos/primary_dark-8fb2eab1.png";